export default "__VITE_ASSET__DqDxFgvi__"